// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"628":"059655e3","737":"d0f039aa","763":"e125ca7d","782":"4c84e987","945":"bf37c527","972":"56acdd93"}[chunkId] + ".chunk.css";
};